<template>
    <a class="custom-work-executive-picker-item">
        <CustomWorkAvatar :executive="executive" size="medium" />
        <span class="primary-link">{{ executive.colloquialName }}</span>
        <div class="subtitle">{{ subtitle }}</div>
        <i class="material-icons" @click.stop.prevent="remove" v-if="editable">clear</i>
    </a>
</template>
<script>
import CustomWorkAvatar from './CustomWorkAvatar'

export default {
    components: {
        CustomWorkAvatar,
    },
    props: {
        editable: {
            type: Boolean,
            default: false,
        },
        executive: {
            type: Object,
            required: true,
        },
    },
    computed: {
        subtitle() {
            return [this.executive.currentCompany?.name, this.executive.position].filter(i => i).join(' - ')
        },
    },
    methods: {
        remove() {
            this.$emit('remove', this.executive)
        },
    },
}
</script>
<style>
.custom-work-executive-picker-item {
    display: grid;
    grid-template-columns: 48px 1fr 24px;
    grid-template-rows: 24px 24px;
    column-gap: 16px;
    padding: 8px 16px;
    align-items: center;
    white-space: nowrap;

    .avatar {
        grid-column: 1;
        grid-row: 1 / 3;
    }

    .primary-link {
        grid-column: 2;
        grid-row: 1;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .subtitle {
        grid-column: 2;
        grid-row: 2;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    i {
        cursor: pointer;
        grid-column: 3;
        grid-row: 1 / 3;
    }
}
</style>
